import $eeTxA$TagCloud from "TagCloud";
import {useRef as $eeTxA$useRef, useEffect as $eeTxA$useEffect, createElement as $eeTxA$createElement} from "react";



const $d415641d0cfd8c85$var$getIsInitialized = (id)=>{
    const key = "__tag-cloud-" + id;
    if (key in window) return Boolean(window[key]);
    return window[key] = false;
};
const $d415641d0cfd8c85$var$setIsInitialized = (id, value)=>{
    const key = "__tag-cloud-" + id;
    window[key] = value;
};
const $d415641d0cfd8c85$export$61a620005b8c73bd = (props)=>{
    const ref = (0, $eeTxA$useRef)(null);
    const key = [
        props.id,
        props.className,
        JSON.stringify(props.children)
    ].join("-");
    (0, $eeTxA$useEffect)(()=>{
        if ($d415641d0cfd8c85$var$getIsInitialized(key) || !ref.current) return;
        if (props.children.length === 0) {
            console.error("TagCloud: No children provided.");
            return;
        }
        const options = props.options ? typeof props.options == "function" ? props.options(window) : props.options : {};
        const tagCloud = (0, $eeTxA$TagCloud)(ref.current, props.children, options);
        $d415641d0cfd8c85$var$setIsInitialized(key, true);
        if (props.onClick) {
            const elements = Array.from(ref.current.getElementsByClassName(options.itemClass ?? "tagcloud--item"));
            if (props.onClick) for (const el of elements)el.addEventListener("click", (event)=>{
                props.onClick(el.innerText, event);
            }, props.onClickOptions);
        }
        return ()=>{
            try {
                tagCloud?.destroy();
            } finally{
                $d415641d0cfd8c85$var$setIsInitialized(key, false);
            }
        };
    }, [
        ref,
        key,
        props
    ]);
    return (0, $eeTxA$createElement)("div", {
        id: props.id,
        className: props.className,
        style: props.style,
        ref: ref
    });
};
var $d415641d0cfd8c85$export$2e2bcd8739ae039 = $d415641d0cfd8c85$export$61a620005b8c73bd;


export {$d415641d0cfd8c85$export$61a620005b8c73bd as TagCloud, $d415641d0cfd8c85$export$2e2bcd8739ae039 as default};
